import { type DependencyList, useEffect, useMemo } from 'react';

import debounce, { type DebouncedFunc } from 'lodash-es/debounce';

/**
 * Returns a debounced version of the callback that auto-cleans up
 * (flush) on unmount or when deps change.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useDebouncedCallback = <T extends (...args: any[]) => any>(
  callback: T,
  delay: number,
  deps: DependencyList
): DebouncedFunc<T> => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedFn = useMemo(() => debounce(callback, delay), deps);

  useEffect(() => {
    return () => {
      debouncedFn.flush();
    };
  }, [debouncedFn]);

  return debouncedFn;
};

export default useDebouncedCallback;
